import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash';

import { useOrderCampaignContent, useOrderPlaylistContent } from "../../../queries";
import { onDragEnd } from "../../../config/global";

import CampaignCard from "./CampaignCard";
import PlaylistCard from "./PlaylistCard";
import PlaylistBuilderRow from "./PlaylistBuilderRow";

const taskStatus = {
    layer: {
        name: "Main layer",
        items: [],
    }
};

function DragDrop({ data, areaId, isDarkMode = false, isAreaMuted = false, onPublish, isCompact = false, showDuration = false, centeredDuration = false, onPreview, builderRow = false, isPlaylistOpen, onTogglePlaylistOpen, playlistId, playlistLayer, onOpenItemSettings }) {
    const orderCampaign = useOrderCampaignContent();
    const orderPlaylist = useOrderPlaylistContent();
    const paused = useSelector((state) => state.device.paused[areaId]);
    const isTouchDevice =
        typeof window !== "undefined" &&
        (window.matchMedia?.("(pointer: coarse)")?.matches || navigator.maxTouchPoints > 0);

    useEffect(() => {
        taskStatus.layer.items = data;
        setColumns(taskStatus)
    }, [data])

    useEffect(() => {
        if (typeof document === "undefined") return;
        document.body.classList.add("dragdrop-active");
        return () => {
            document.body.classList.remove("dragdrop-active");
        };
    }, []);

    taskStatus.layer.items = data;
    const [columns, setColumns] = useState(taskStatus);

    const didMountRef = useRef(false);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        } else if (columns && Object.keys(columns).length > 0) {
            if (!_.isEqual(columns.layer.items, data)) {
                order();
            }
        }
    }, [columns]);

    const order = async () => {
        let pathName = window.location.pathname
        if (columns.layer.items.length > 0)
            if ((pathName.includes("campaign") || pathName.includes("layout"))) {
                let campaignPlaylistMediaIds = Object.entries(columns.layer.items).map(item => item[1].campaign_playlist_media_id);
                await orderCampaign.mutateAsync({ "campaign_playlist_ids": campaignPlaylistMediaIds ?? [] })
            } else {
                let PlaylistMediaIds = Object.entries(columns.layer.items).map(item => item[1].playlist_media_id);
                await orderPlaylist.mutateAsync({ "playlistmedia_ids": PlaylistMediaIds ?? [] })
            }
    }

    const getDraggableId = (item, index) => String(item?.id ?? item?.campaign_playlist_media_id ?? item?.playlist_media_id ?? `item-${index}`);

    // v15 media preview — row-thumbnail clicks open the lightbox scoped to
    // THIS row list's own visual siblings (task spec: "the navigable list is
    // every visual... sibling in that SAME row list"). CampaignCard.jsx/
    // PlaylistBuilderRow.jsx only ever call `onPreview(item)` (single arg,
    // unchanged) — `data` (this whole list) is appended here, where it's
    // already in scope, so neither row component's own signature/contract
    // needs to change.
    const onRowPreview = onPreview ? (item) => onPreview(item, data) : undefined;






    /* -------------------------------------------------------------------------- */
    /*                                Preview Logic                               */
    /* -------------------------------------------------------------------------- */

    /* -------------------------------------------------------------------------- */
    /*                                Preview Logic                               */
    /* -------------------------------------------------------------------------- */
    
    // Get playback status for this area from Redux
    const playbackStatus = useSelector((state) => state.device.playbackStatus && state.device.playbackStatus[areaId]);


    // We no longer simulate playback locally. We rely on playbackStatus.
    // playbackStatus = { currentItemId, totalDuration, progress }





    // Render unified drag-and-drop version for both mobile and desktop
    return (
        <>
            <div className="d-flex flex-column justify-content-center"   >
                <DragDropContext onDragEnd={(result) => { onDragEnd(result, columns, setColumns) }} className="w-100" >
                    {Object.entries(columns).map(([columnId, column], index) => {
                        return (
                            <div className="d-flex flex-column align-items-center" key={columnId}>
                                <Droppable droppableId={columnId} key={columnId}>
                                    {(provided, snapshot) => {
                                        return (
                                            <div {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="  droppable_container scroll_div"
                                            >
                                                {column?.items?.map((item, index) => {
                                                    const draggableId = getDraggableId(item, index);
                                                    return (
                                                        <Draggable key={draggableId} draggableId={draggableId} index={index} >
                                                            {(provided, snapshot) => {
                                                                return (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...(!isTouchDevice ? provided.dragHandleProps : {})}
                                                                        style={{
                                                                            userSelect: "none",
                                                                            ...provided.draggableProps.style,
                                                                        }}
                                                                        className={`draggable_container px-0 px-sm-2 ${builderRow ? `pp-cb-draggable${index === (column?.items?.length ?? 0) - 1 ? ' pp-cb-draggable--last' : ''}` : ''}`}>

                                                                        {!window.location.pathname.includes("playlist") ?
                                                                            <CampaignCard
                                                                                isActive={playbackStatus?.currentItemId === item.id}
                                                                                progress={playbackStatus?.currentItemId === item.id ? playbackStatus?.progress : 0}
                                                                                item={item}
                                                                                isDarkMode={isDarkMode}
                                                                                isAreaMuted={isAreaMuted}
                                                                                dragHandle={isTouchDevice ? provided.dragHandleProps : null}
                                                                                isDragging={snapshot.isDragging}
                                                                                index={index}
                                                                                totalItems={column?.items?.length || 0}
                                                                                onPublish={onPublish}
                                                                                isCompact={isCompact}
                                                                                showDuration={showDuration}
                                                                                centeredDuration={centeredDuration}
                                                                                areaId={areaId}
                                                                                onPreview={onRowPreview}
                                                                                builderRow={builderRow}
                                                                                isPlaylistOpen={isPlaylistOpen}
                                                                                onTogglePlaylistOpen={onTogglePlaylistOpen}
                                                                            />
                                                                            : builderRow ?
                                                                            <PlaylistBuilderRow
                                                                                item={item}
                                                                                layer={playlistLayer}
                                                                                playlistId={playlistId}
                                                                                index={index}
                                                                                totalItems={column?.items?.length || 0}
                                                                                dragHandle={isTouchDevice ? provided.dragHandleProps : null}
                                                                                onPreview={onRowPreview}
                                                                                onOpenSettings={onOpenItemSettings}
                                                                            />
                                                                            :
                                                                            <PlaylistCard
                                                                                item={item}
                                                                                isDarkMode={isDarkMode}
                                                                                isAreaMuted={isAreaMuted}
                                                                                dragHandle={isTouchDevice ? provided.dragHandleProps : null}
                                                                                isDragging={snapshot.isDragging}
                                                                                index={index}
                                                                                totalItems={column?.items?.length || 0}
                                                                                onPublish={onPublish}
                                                                            />
                                                                        }
                                                                    </div>
                                                                );
                                                            }}
                                                        </Draggable>
                                                    );
                                                })}
                                                {provided.placeholder}
                                            </div>
                                        );
                                    }}
                                </Droppable>
                            </div>
                        );
                    })}
                </DragDropContext>
            </div>
        </>
    )
}

export default DragDrop
